import { Field } from 'ngx-angular-query-builder';
import { FilterOperators, FieldMetadataCollection, FilterFieldProvider, FieldMetadataCollectionBuilder } from '@common/filter/filtering';
import { IRow, ITable } from '@common/models/table';
import { ArrayToFilterListItemBuilder, asDate, mapDate } from '@common/filter/services/array-to-filter-list-item-builder';


export class UserInvoicesAndReceiptsWidgetFilterFieldProvider implements FilterFieldProvider {

  private readonly fieldMetaDataCollection = new FieldMetadataCollection();

  constructor(private readonly tableData: ITable) {

    const fieldMetaDataBuilder = new FieldMetadataCollectionBuilder(this.fieldMetaDataCollection);
    const optionBuilder = new ArrayToFilterListItemBuilder(tableData ? tableData.Rows : []);
    const sysOption = (s: string) => optionBuilder.forProperty(s, s, (x: IRow) => x[s]);

    optionBuilder.add('SystemInvoiceDate', (x: any) => asDate(x.SystemInvoiceDate), mapDate('SystemInvoiceDate'));
    sysOption('SystemInvoiceRef');
    sysOption('SystemInvoiceStyle');
    sysOption('SystemNetAmount');

    const options = optionBuilder.build();

    const addFilter = (label: string,
      optionsName: string,
      type: string,
      ops: string[]) => fieldMetaDataBuilder.add(label, optionsName, type, ops, options.get(optionsName));

    addFilter('Date', 'SystemInvoiceDate', 'date', FilterOperators.DateDefaults);
    addFilter('Document Ref', 'SystemInvoiceRef', 'string', FilterOperators.StringDefaults);
    addFilter('Description', 'SystemInvoiceStyle', 'string', FilterOperators.StringDefaults);
    addFilter('Amount', 'SystemNetAmount', 'number', FilterOperators.Scalar);
  }

  getFilterFields(): Array<Field> {
    return this.fieldMetaDataCollection.getFilterFields();
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }

}